<template>
    <div>
        <v-dialog v-model="dialog" max-width="900" persistent>
            
            <div class="text-center" style="font-family:Sans-serif">
                <center>
                    <v-overlay v-model="overlay">
                        <v-progress-circular
                            indeterminate
                            :size="120"
                            :width="3">
                        </v-progress-circular>Loading,please wait...
                    </v-overlay>
                </center>
            </div>
            <div>
                <v-card>
                    <v-card-title class="mb-2">
                        <span class="headline">図面仕上がり予定表</span>
                        <v-spacer/>
                        <v-icon medium color="red" @click="toggleDialogBossSchedule(false)">mdi-close</v-icon>
                    </v-card-title>
                    <v-card-text>
                        <div v-if="bossScheduleData.length > 0">
                            <v-simple-table class="mainTable">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>FILE TYPE(CODE)</th>
                                        <th>BOSS REMARKS</th>
                                        <th>DUE DAY</th>
                                        <th v-if="loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1">ACTION</th>
                                        <th>HRD ID</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in bossScheduleData" :key="index">
                                        <td>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon color="primary" large v-bind="attrs" v-on="on">mdi-check-bold</v-icon>
                                                </template>
                                                <span>Registered</span>
                                            </v-tooltip>
                                            
                                        </td>
                                        <!-- <td>{{ item.code_arrangement }} - {{ item.plan_type }}</td> -->
                                        <td>{{ item.plan_type }}</td>
                                        <td>{{ item.cad_remarks }}</td>
                                        <td v-if="(loggedInUser.is_admin != 1 && loggedInUser.plan_control != 1) && item.boss_code == '202'">{{ item.due_day_boss ? item.due_day_boss : '-' }}</td>
                                        <td v-else>{{ item.due_day ? item.due_day : '-' }}</td>
                                        <td v-if="loggedInUser.is_admin == 1 || loggedInUser.plan_control == 1">
                                            <v-btn icon @click="openChangeDueDialog(item, index)">
                                                <v-icon large color="green">mdi-circle-edit-outline</v-icon>
                                            </v-btn>
                                            <v-btn @click="deleteBundleSched(item)" icon v-if="item.boss_code == 'P76' || item.boss_code == '127' || item.boss_code == 'J13' || item.boss_code == '966'">
                                                <v-icon large color="red">mdi-delete-forever-outline</v-icon>
                                            </v-btn>
                                        </td>
                                        <td>{{item.HRD_ID}}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>

                            <v-card-actions>
                                <v-btn v-if="editMode" @click="updateRegisteredData()" dark color="green">SAVE</v-btn>
                            </v-card-actions>
                        </div>
                        
                        <div v-else class="mt-5 text-center">
                            <span>No data available</span>
                        </div>
                    </v-card-text>
                </v-card>
            </div>
        </v-dialog>


    <v-dialog v-model="changeDueDialog" width="400">
        <div>
            <v-card>
                <v-card-title>
                    Edit Due Date/Time
                </v-card-title>
                <v-card-text>
                    <v-row>

                        <v-col>
                            <v-menu
                                v-model="dueDateMenu"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        outlined
                                        dense
                                        v-model="changedDueDateTime.date"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on">
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="changedDueDateTime.date"
                                    @input="dueDateMenu = false"
                                >
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col>
                            <v-text-field v-model="changedDueDateTime.time"
                                outlined
                                dense
                                :label="label"
                                :value="changedDueDateTime.time"
                                :rules="timeRules"
                                required
                                v-time-format
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-card-actions>
                        <v-btn dark @click="closeDueDialog()" color="green" dense>保存</v-btn>
                    </v-card-actions>
                </v-card-text>
            </v-card>
        </div>
    </v-dialog>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import moment from 'moment';
import Swal from 'sweetalert2'
export default {
    props: {
        dialog: Boolean
    },

    data(){
        return {

            schedule: [],
            overlay: false,
            editMode: false,
            dueDateMenu: false,
            dueDate: null,
            bundleIndex: 0,
            changeDueDialog: false,
            dueDateMenu: false,
            dueDate: null,
            changedDueDateTime: {
                time: null,
                date: null,
            },
            label: 'Time',
            timeRules: [
                v => !!v || 'Time is required', // Required validation
                v => /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(v) || 'Invalid time format' // Regex validation for time format (HH:mm)
            ]
        }
    },
    directives: {
        'time-format': {
        // Insert a colon after entering 2 digits for the hour part
            bind(el) {
                el.addEventListener('input', function (event) {
                    const inputValue = event.target.value;
                    if (inputValue.length === 2 && !inputValue.includes(':')) {
                        event.target.value = inputValue + ':';
                    }
                });
            }
        },  
    },

    computed: {
        ...mapState([
            'bossScheduleData',
            'loggedInUser'
        ]),
    },
    

    methods: {
        updateRegisteredData(){
            let itemArr = [];
            // itemArr.push(item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes"
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: "POST",
                        url: `api/update_registered`,
                        data: {
                            user : this.$store.state.loggedInUser,
                            bossData: this.bossScheduleData
                        }
                    }).then(({data}) => {
                        if(data == 'success'){
                            this.$emit('triggerSocketBossSending', this.bossScheduleData, 'Edit');
                            this.toggleDialogBossSchedule(false);
                            this.editMode = false;
                        }else{
                            Swal.fire({
                                icon: "error",
                                title: data,
                            });
                        }
                    })

                }
            });
        },
        closeDueDialog(){   
            let newDueDate = moment().format(`${this.changedDueDateTime.date} ${this.changedDueDateTime.time}`);
            this.bossScheduleData[this.bundleIndex].due_day = newDueDate;
            this.changeDueDialog = false;
        },
        openChangeDueDialog(item, ii){
            this.editMode = true;
            this.bundleIndex = ii
            // Check if item.due_day is a valid date before formatting
            if (moment(item.due_day).isValid()) {
                this.changeDueDialog = true;
                this.changedDueDateTime.time = moment(item.due_day).format("HH:mm");
                this.changedDueDateTime.date = moment(item.due_day).format("YYYY-MM-DD");
            } else {
                // Handle the case where item.due_day is not a valid date
                console.error("Invalid date format in item.due_day:", item.due_day);
                // You might want to set a default value or show an error message here.
            }
        },
        editRegistered(item){
            let itemArr = [];
            itemArr.push(item);

            axios({
                method: "POST",
                url: `api/update_registered`,
                data: {
                    user : this.$store.state.loggedInUser,
                    bossData: item
                }
            }).then(({data}) => {
                if(data == 'success'){
                    this.$emit('triggerSocketBossSending', itemArr, 'ADD');
                    this.toggleDialogBossSchedule(false);
                }else{
                    Swal.fire({
                        icon: "error",
                        title: data,
                    });
                }
            })

            Swal.fire({
                title: "Are you sure?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes"
            }).then((result) => {
                if (result.isConfirmed) {


                }
            });
        },

        toggleDialogBossSchedule(value){
            this.$emit('toggleDialogBossSchedule', value)
        },
        editBundleSched(ii){
            this.editMode = true;
            this.bundleIndex = ii;
            // this.dueDate = item.due
        },
        deleteBundleSched(item){
            // console.log(item)
            let itemArr = [];
            itemArr.push(item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes, delete it!"
            }).then((result) => {
                if (result.isConfirmed) {
                    axios({
                        method: "POST",
                        url: `api/delete_registered`,
                        data: {
                            user : this.$store.state.loggedInUser,
                            bossData: item
                        }
                    }).then(({data}) => {
                        if(data == 'success'){
                            this.$emit('triggerSocketBossSending', itemArr, 'DELETE');
                            this.toggleDialogBossSchedule(false);
                        }else{
                            Swal.fire({
                                icon: "error",
                                title: data,
                            });
                        }
                    })

                }
            });
            // this.$emit('triggerSocketBossSending', itemArr, 'DELETE');
        },

        // confirmAlvs(){
        //     this.$emit('confirmAlvs', this.selected)
        //     this.toggleDialogBossSchedule(false)
        // }
    },

    watch: {
        dialog(val){
            if(val){
                // this.overlay = true
                // setTimeout(() => {
                //     this.overlay = false
                // }, 3000);
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>